
<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'ClientDemographicsGraph',
  extends: Bar,
  props: {
    clientDemographics: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    demographicFields: [
      'Under 40',
      '41-50',
      '51-60',
      '61-70',
      '71-80',
      '81+',
    ],

    graphData: {
      labels: [
        ['Under', 'Age 40'],
        ['Age', '41-50'],
        ['Age', '51-60'],
        ['Age', '61-70'],
        ['Age', '71-80'],
        ['Age', '81+'],
      ],
      datasets: [
        {
          label: 'Assets',
          data: [1, 2, 3, 4, 5, 6],
          backgroundColor: '#97C131',
          barPercentage: 0.9,
          minBarLength: 10,
          categoryPercentage: 0.7,
        },
        {
          label: 'Age',
          data: [2, 3, 4, 5, 6, 7],
          backgroundColor: '#0096A6',
          barPercentage: 0.9,
          minBarLength: 10,
          categoryPercentage: 0.7,
        },
      ],
    },
    graphOptions: {
      maintainAspectRatio: false,
      responsive: true,
      layout: {
        padding: {
          top: 30,
          left: 10,
        },
      },
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 15,
        },
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            maxRotation: 0,
          },
        }],
        yAxes: [{
          gridLines: {
            drawBorder: false,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            maxRotation: 0,
            min: 0,
            maxTicksLimit: 10,
            callback: value => `${value}%`,
          },
        }],
      },
      tooltips: {
        callbacks: {
          title: ([{ label }]) => {
            return (label || '').replace(/[,]/g, ' ')
          },
          label: ({ datasetIndex, value }, data) => {
            return `${data.datasets[datasetIndex].label}: ${value}%`
          },
        },
      },
    },
  }),

  mounted () {
    this.buildGraphData()
    this.renderChart(this.graphData, this.graphOptions)
  },

  methods: {
    buildGraphData () {
      if (!this.clientDemographics) return

      this.graphData.datasets[0].data = []
      this.graphData.datasets[1].data = []

      this.demographicFields.forEach(field => {
        const { age, assets } = (this.clientDemographics[field] || {})

        this.graphData.datasets[0].data.push(assets || 0)
        this.graphData.datasets[1].data.push(age || 0)
      })
    },
  },
}
</script>

<style scoped>
div {
  max-height: 400px;
  max-width: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/partials/ClientDemographicsGraph.vue